import { render, staticRenderFns } from "./kdxSvgIcon.g.vue?vue&type=template&id=6d37a33b&scoped=true"
import script from "./kdxSvgIcon.g.vue?vue&type=script&lang=js"
export * from "./kdxSvgIcon.g.vue?vue&type=script&lang=js"
import style0 from "./kdxSvgIcon.g.vue?vue&type=style&index=0&id=6d37a33b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37a33b",
  null
  
)

export default component.exports